/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreYandexGamesYandexBonusErrorResult, FxIdApplicationStoreYandexGamesYandexBonusErrorResultFromJSONTyped, FxIdApplicationStoreYandexGamesYandexBonusErrorResultToJSON, } from './FxIdApplicationStoreYandexGamesYandexBonusErrorResult';
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataFromJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusErrorResult(json)) {
        return FxIdApplicationStoreYandexGamesYandexBonusErrorResultFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataToJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusErrorResult(value)) {
        return FxIdApplicationStoreYandexGamesYandexBonusErrorResultToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesYandexBonusResultDataErrorData.js.map